"use client";

import { useId, useState } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { CloseButton } from "../../icons";
import { promoConfig, promoHeaderText, promoHeaderTooltipText } from "../promoBanner/promoTextConfig";

import styles from "./HeaderPromoBanner.module.scss";

interface HeaderPromoBannerProps {
  textColor?: string;
  backgroundColor?: string;
  format?: keyof typeof promoConfig;
  promoText?: string;
  tooltipText?: string;
}

export const ExecEdHeaderPromoBanner = function ({
  textColor,
  backgroundColor,
  promoText,
  format = "US",
  tooltipText,
}: HeaderPromoBannerProps) {
  const [isVisible, setIsVisible] = useState(true);
  const tooltipId = useId();
  const handleClose = () => {
    setIsVisible(false);
  };

  const content = promoText || promoHeaderText(format);
  const resolvedTooltipText = tooltipText || promoHeaderTooltipText(format);

  if (!content) return null;

  return (
    <div
      id="headerPromoBanner"
      className={`${styles.wrapper} ${isVisible ? styles.visible : styles.hidden}`}
      style={{ backgroundColor }}
    >
      <div className={styles.container}>
        <p style={{ color: textColor, textWrap: "balance" }}>
          <span dangerouslySetInnerHTML={{ __html: content }} />
          {resolvedTooltipText && (
            <>
              <button
                className={styles.tooltipButton}
                data-tooltip-id={tooltipId}
                aria-label="More information"
                type="button"
              >
                <sup>
                  <i className="icon-info" aria-hidden="true" style={{ fontSize: "0.8em", fontStyle: "normal" }}>
                    ⓘ
                  </i>
                </sup>
              </button>
              <ReactTooltip
                id={tooltipId}
                place="bottom"
                style={{
                  backgroundColor: "#333",
                  color: "#fff",
                  maxWidth: "300px",
                  fontSize: "12px",
                  zIndex: 10000,
                  fontStyle: "normal",
                }}
              >
                {resolvedTooltipText}
              </ReactTooltip>
            </>
          )}
        </p>
        <button className={styles.closeButton} onClick={handleClose}>
          <CloseButton fill={textColor} />
        </button>
      </div>
    </div>
  );
};
